import styled from 'styled-components'
import pxToRem from '../../utils/pxToRem'
import Button from '../Button/Button'
import ArrowDownIcon from '../../images/icons/arrow-down.svg'
import AddIcon from '../../images/icons/add.svg'
import LessIcon from '../../images/icons/less.svg'
import { CollapseEnumType } from './Collapse'

export const StyledCollapse = styled.li`
  position: relative;
  flex-direction: column;
  overflow: hidden;
  display: flex;
  border-radius: ${({ $collapseType, $level }) =>
    $collapseType === CollapseEnumType.Navbar && $level === 0
      ? `0 ${pxToRem(5)} ${pxToRem(30)} 0`
      : $collapseType === CollapseEnumType.Navbar && $level === 1
      ? `0 ${pxToRem(5)} ${pxToRem(30)} 0`
      : '0'};
  margin-left: ${({ $level, $collapseType }) =>
    $level === 1 || $level === 0 || $collapseType === CollapseEnumType.SideNav
      ? '0'
      : pxToRem(4)};
  background-color: ${({ $bgColor }) => $bgColor};
`
export const StyledDash = styled.div`
  position: absolute;
  top: ${pxToRem(24)};
  left: ${pxToRem(10)};
  width: ${pxToRem(20)};
  height: ${pxToRem(2)};
  background-color: ${({ $isOpen, theme }) =>
    $isOpen ? theme.colors.primary.lime : theme.colors.unique.black};
  padding-left: ${({ isChild }) => (isChild ? pxToRem(10) : 'inherit')};
`

//TODO : see what happened when page uis selected
export const StyledCollapseHeader = styled.div`
  align-items: center;
  flex-direction: row;
  display: flex;
`

export const StyledParagraph = styled.p`
  width: 100%;
  display: block;
  margin-right: ${pxToRem(20)};
  cursor: pointer;
  padding: ${({ $collapseType, $isChild }) => {
    switch ($collapseType) {
      case CollapseEnumType.Navbar:
        return $isChild
          ? `${pxToRem(22.5)} 0 ${pxToRem(22.5)} ${pxToRem(30)}`
          : `${pxToRem(22.5)} 0 ${pxToRem(22.5)} ${pxToRem(20)}`
      case CollapseEnumType.SideNav:
        return $isChild
          ? `${pxToRem(15)} 0 ${pxToRem(15)} ${pxToRem(51)}`
          : `${pxToRem(15)} 0 ${pxToRem(15)} ${pxToRem(41)}`
      default:
        return $isChild
          ? `${pxToRem(15)} 0 ${pxToRem(15)} ${pxToRem(51)}`
          : `${pxToRem(15)} 0 ${pxToRem(15)} ${pxToRem(41)}`
    }
  }};
  background-color: inherit;
  font-size: ${({ theme }) => theme.fonts.sizes.button};
  font-weight: ${({ $isSelected, $isChild, $collapseType, theme }) =>
    ($isSelected || !$isChild) && $collapseType === CollapseEnumType.SideNav
      ? theme.fonts.weight.bold
      : theme.fonts.weight.normal};
  color: ${({ $color }) => $color};
`

export const StyledCollapseLink = styled(Button)`
  width: 100%;
  display: block;
  margin: 0 ${pxToRem(20)} 0 0;
  padding: ${({ $collapseType }) =>
    $collapseType === CollapseEnumType.Navbar
      ? `${pxToRem(22.5)} 0 ${pxToRem(22.5)} ${pxToRem(20)}`
      : `${pxToRem(15)} 0 ${pxToRem(15)} ${pxToRem(41)}`};
  background-color: inherit;
  font-size: ${({ theme }) => theme.fonts.sizes.button};
  font-weight: ${({ $isSelected, $isChild, $collapseType, theme }) =>
    ($isSelected || !$isChild) && $collapseType === CollapseEnumType.SideNav
      ? theme.fonts.weight.bold
      : theme.fonts.weight.normal};
  color: ${({ $color }) => $color};
  text-align: left;
`

export const StyledVerticalDash = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: ${pxToRem(4)};
  height: 100%;
  background-color: ${({ $isSelected, theme }) =>
    $isSelected ? theme.colors.primary.blue : theme.colors.unique.black};
`

export const StyledCollapseContainer = styled.div`
  flex-direction: column;
  display: ${({ $isOpen }) => ($isOpen ? 'flex' : 'none')};
  border-radius: ${({ $collapseType }) =>
    $collapseType === CollapseEnumType.Navbar
      ? `0 ${pxToRem(5)} ${pxToRem(30)} 0`
      : '0'};
  background-color: ${({ theme }) => theme.colors.secondary.whitesmoke};
`

export const StyledArrowDownIcon = styled(ArrowDownIcon)`
  ${({ $isOpen }) => $isOpen && 'transform: rotate(180deg)'};
`
export const StyledAddIcon = styled(AddIcon)``

export const StyledLessIcon = styled(LessIcon)``
